import React, { useState, useEffect } from "react";
import axios from "axios";
import "./output.css";

function App() {
  const [imageUrl1, setImageUrl1] = useState("");
  const [imageUrl2, setImageUrl2] = useState("");
  const [imageUrl3, setImageUrl3] = useState("");
  const [imageUrl4, setImageUrl4] = useState("");
  const [correctBreed, setCorrectBreed] = useState("");
  const [dogFact, setDogFact] = useState("");
  const [currentScore, setCurrentScore] = useState(0);

  useEffect(() => {
    fetchRandomImages();
  }, []);

  const fetchRandomImages = async () => {
    const responses = await Promise.all([
      axios.get("https://dog.ceo/api/breeds/image/random"),
      axios.get("https://dog.ceo/api/breeds/image/random"),
      axios.get("https://dog.ceo/api/breeds/image/random"),
      axios.get("https://dog.ceo/api/breeds/image/random"),
      axios.get("https://dogapi.dog/api/v2/facts"),
    ]);

    const [data1, data2, data3, data4, data5] = responses.map(
      (response) => response.data,
    );

    const randomBreeds = [
      data1.message,
      data2.message,
      data3.message,
      data4.message,
    ];
    const chosenIndex = Math.floor(Math.random() * 4); // Randomly choose correct image
    setCorrectBreed(randomBreeds[chosenIndex]); // Set correct breed
    setImageUrl1(data1.message);
    setImageUrl2(data2.message);
    setImageUrl3(data3.message);
    setImageUrl4(data4.message);
    setDogFact(data5.data[0].attributes.body);
  };

  const handleImageClick = (imageUrl) => {
    if (imageUrl === correctBreed) {
      setCurrentScore(currentScore + 1);
      fetchRandomImages(); // Start new round on correct answer
    } else {
      // No point deduction for wrong answer in this simplified version
      fetchRandomImages(); // Start new round on wrong answer
    }
  };

  const displayBreedName = correctBreed
    ?.split("breeds/")?.[1]
    ?.split("/")[0]
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.substring(1))
    .reverse()
    .join(" ");
  const styles = {
    display: "grid",
    gridTemplateColumns: "auto auto",
    gridTemplateRows: "auto auto",
  };
  return (
    <div className="flex max-h-screen min-h-screen flex-col items-center justify-center bg-[#fffef0] px-2 pt-4 sm:p-0">
      <div
        className="background-animate flex w-full basis-1/5 select-none 
      flex-col content-center items-center justify-center  bg-gradient-to-r pt-2 from-indigo-500 via-purple-500 to-pink-500 bg-clip-text text-3xl font-bold text-transparent sm:text-3xl md:text-5xl"
      >
        What Kind Dog!?
        <div className="flex flex-row text-center text-lg text-[#3d348b] ">
          Score: {currentScore} <img height={34} width={34} src="/paw.svg" />
        </div>
      </div>
      <div style={styles} className="grow basis-3/5 gap-2 max-w-lg">
        <img
          className="animate-slobounce self-end rounded-md hover:border-4 hover:border-pink-400 box-border"
          src={imageUrl1}
          alt="Dog 1"
          onClick={() => handleImageClick(imageUrl1)}
        />
        <img
          className="animate-slobounce self-end rounded-md hover:border-4 hover:border-pink-400 box-border"
          src={imageUrl2}
          alt="Dog 1"
          onClick={() => handleImageClick(imageUrl2)}
        />
        <img
          className="animate-slobounce self-end rounded-md hover:border-4 hover:border-pink-400 box-border"
          src={imageUrl3}
          alt="Dog 3"
          onClick={() => handleImageClick(imageUrl3)}
        />
        <img
          className="animate-slobounce self-end rounded-md hover:border-4 hover:border-pink-400 box-border"
          src={imageUrl4}
          alt="Dog 4"
          onClick={() => handleImageClick(imageUrl4)}
        />
      </div>
      <div className=" pb-2 mx-auto my-4 flex w-4/5 max-w-[900px] basis-2/5 flex-col items-center justify-center rounded-md bg-[#8f592297] bg-opacity-70 p-2 text-center text-lg font-bold shadow-xl ">
        <div className="flex flex-row items-center gap-1 text-center text-lg text-[#7678ed] sm:text-2xl">
          Find the<div className="text-[#f7b801]">{displayBreedName}</div>
        </div>
        <div className="mt-2 rounded-sm bg-slate-200 p-1 text-center text-sm text-[#7678ed]">
          fun fact: {dogFact}
        </div>
      </div>
    </div>
  );
}

export default App;
